import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImportsMonitoringItem } from 'exports/interfaces/imports-monitoring-channel.interface';
import { BaseTooltip } from 'shared/abstract/base-tooltip';

@Component({
    selector: 'app-import-partial-success-status-bar-tooltip',
    imports: [TranslateModule],
    templateUrl: './import-partial-success-status-bar-tooltip.component.html',
    styleUrl: './import-partial-success-status-bar-tooltip.component.scss',
})
export class ImportPartialSuccessStatusBarTooltipComponent extends BaseTooltip {
    public data: ImportsMonitoringItem | null = null;
}
